import { render, staticRenderFns } from "./app-settings.vue?vue&type=template&id=3089f6d4"
import script from "./app-settings.vue?vue&type=script&lang=js"
export * from "./app-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports